var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.27 10.46a.89.89 0 0 0 0 1.28c.36.35.94.35 1.3 0l5.16-5.1a.89.89 0 0 0 0-1.28L1.57.26a.93.93 0 0 0-1.3 0 .89.89 0 0 0 0 1.28L4.5 6 .27 10.46z","fill":"#A9B0B7","fillRule":"evenodd"}));
}

Chevron.displayName = "Chevron";

Chevron.defaultProps = {"viewBox":"0 0 7 12"};

module.exports = Chevron;

Chevron.default = Chevron;
